import Icon from '../components/Icon.vue'

Icon.register({
  language: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M304 416H24C10.7 416 0 405.3 0 392V120C0 106.7 10.7 96 24 96H304V416zM183.3 343.4A12-12 0 0 1 194.8 352H217.7C225.9 352 231.7 343.9 229.1 336.1L171.6 167.1A12-12 0 0 1 160.2 158.9H127.8A12-12 0 0 1 116.4 167.1L58.9 336.1C56.3 343.9 62.1 352 70.3 352H93.1A12-12 0 0 1 104.6 343.3L113.8 311.5H174L183.3 343.4zM144.3 203S148.6 224 152.1 236.2L162.9 273.7H124.8L135.9 236.2C139.4 224 143.7 203 143.7 203H144.3zM616 416H336V96H616C629.3 96 640 106.7 640 120V392C640 405.3 629.3 416 616 416zM580 188H516V172C516 165.4 510.6 160 504 160H488C481.4 160 476 165.4 476 172V188H412C405.4 188 400 193.4 400 200V216C400 222.6 405.4 228 412 228H526.1C519.8 242.3 509.6 257 496.1 271.2 489.5 264.3 483.7 257.3 478.7 250.3 475.1 245.1 468.1 243.6 462.7 246.8L455.4 251.2 448.9 255.1C443 258.6 441.3 266.5 445.2 272.2 451.3 280.9 458.3 289.5 466.2 297.9 458.1 304.1 449.4 310.1 440.1 315.9 434.6 319.3 432.7 326.4 435.9 332L443.9 345.9C447.2 351.8 454.8 353.8 460.6 350.2 473.3 342.4 485.1 334 496 325.3 506.9 334.1 518.8 342.4 531.4 350.2 537.2 353.8 544.8 351.8 548.1 345.9L556.1 332C559.3 326.4 557.4 319.3 551.9 315.9A312.7-312.7 0 0 0 525.9 297.8C546.9 275.4 561.6 251.6 568.6 228H580C586.6 228 592 222.6 592 216V200C592 193.4 586.6 188 580 188z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/language.js
// module id = ME0X
// module chunks = 144